import { Global } from './Global';
export class Cache {

  /* Singleton boilerplate */
  private static instance: Cache;

  private constructor() {}

  static getInstance(): Cache {
    const now: Date = new Date();
    if (this.instance == null ||
      this.creationTime == null ||
      now.getTime() - this.creationTime.getTime() > this.oneHourInMs){//Reset the cache every hour
      this.instance = new Cache();
      this.creationTime = new Date();
    }
    return this.instance;
  }

  /* Member variables */
  private urlHistory: Array<string> = [];
  private currentUrl = "";
  private data: any = {};
  private scrollPositions: any = {};
  private static creationTime: Date = null;
  private static oneHourInMs = 3600000;

  addUrlsToHistory(... urls: string[]) {
    if (urls != null) {
      urls.forEach(u => {
        if (u != "" && !this.urlIsInHistory(u)) { //Only add it if it's not empty nor already in it
          this.urlHistory.push(u);
        }
      });
    }
  }

  setCurrentUrl(url: string = "") {
    this.currentUrl = url;
  }

  getCurrentUrl(context): string {
    if (this.currentUrl === ("/" + context.getString("onSaleUrl")) || this.currentUrl === "/charts") {
      return '/' + Global.getCountry() + '/' + Global.getStoreUrl() + '/' + Global.getMediaTypeForUrl() + this.currentUrl;
    }
    return this.currentUrl;
  }

  urlIsInHistory(url: string = ""): boolean {
    if (this.urlHistory){
      return this.urlHistory.indexOf(url) > -1;
    }
    else return false;
  }

  addData(key: string, data: any) {
    this.data[key] = data;
  }

  getData(key: string) {
    return this.data[key];
  }

  saveScrollPosition(key: string, scrollPosition: number) {
    this.scrollPositions[key] = scrollPosition;
  }

  getScrollPosition(key: string): number {
    return this.scrollPositions[key];
  }

  deleteScrollPosition(key: string) {
    this.scrollPositions[key] = null;
  }

  deleteEntriesWithKey(key: string) {
    const keys = Object.keys(this.data);
    if (keys) {
      keys.forEach(k => {
        if (k.indexOf(key) > -1) {
          delete this.data[k];
        }
      });
    }
  }

}
